import { Col } from 'react-bootstrap';

import SwitchCheckbox from '@/ui/components/forms/SwitchCheckbox';
import IconList from '@/ui/components/IconList';

interface Props {
  //icono del item
  icon: string;
  //titulo del item
  title: string;
  //verifica si esta activo o no
  checked: boolean;
  //tamaño de columna principal
  colSize?: number;
  //onChange del componente
  onChange: () => void;
}
const IconSwitch = ({ icon, title, onChange, checked, colSize = 6 }: Props) => {
  return (
    <Col lg={12} className='d-flex justify-content-between my-1'>
      <Col lg={colSize} className='my-auto'>
        <IconList classIcon='pe-2' iconName={icon} classTitle='p-regular-bold' title={title} />
      </Col>
      <Col lg={12 - colSize}>
        <SwitchCheckbox classMain='py-2 px-0' type='switch' showValue={true} checked={checked} onChange={onChange} />
      </Col>
    </Col>
  );
};

export default IconSwitch;
